import { ConfluenceSpaceAri, JiraProjectAri, LoomSpaceAri } from '@atlassian/ari';

import type { TeamContainerType } from '../../types';

export const getContainerType = (containerAri: string): TeamContainerType | undefined => {
	const isConfluenceSpace = ConfluenceSpaceAri.check(containerAri);
	const isJiraProject = JiraProjectAri.check(containerAri);
	const isLoomSpace = LoomSpaceAri.check(containerAri);

	if (isConfluenceSpace) {
		return 'Confluence';
	}

	if (isJiraProject) {
		return 'Jira';
	}

	if (isLoomSpace) {
		return 'Loom';
	}
};
